module.exports = __webpack_public_path__ + "45efeb4e892d8753f20d0bbed6bcd871.svg";